
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Archery Tournament </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2>G. H Raisoni Archery Tournament  <span >  Pune 2023 </span></h2>
		</div>

		<p>The G H Raisoni College of Engineering and Management, in collaboration with the Pune Archery Association,
			successfully organized the 'G H Raisoni Memorial Archery Tournament, 2023' on August 12th. The event took
			place on the campus of G H Raisoni College of Engineering and Management, Pune.</p>
		<p>The tournament had an attractive prize pool of ₹18,000 and provided a captivating platform for participating
			archers to demonstrate their prowess. The primary objective of the event was to nurture sportsmanship skills
			among budding talents in the realm of archery</p>
		<p>The 'Archery Tournament 2023' was a resounding success, showcasing a riveting display of skill, precision,
			and competitive spirit. Skilled archers from diverse regions participated in the competition, displaying the
			culmination of dedication and practice in the sport of archery</p>
		<p>The G H Raisoni College of Engineering and Management, in conjunction with the Pune Archery Association,
			extends heartfelt gratitude to all participants, sponsors, and attendees who contributed to making this
			event a memorable success. As the tournament concluded, it left behind a legacy of camaraderie, talent, and
			the celebration of sportsmanship values.</p>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row mt-5">
			<div class="sec-title text-center">
				<h4>Rank<span >List </span></h4>
			</div>
			<div class="col-md-4">
				<iframe src="https://drive.google.com/file/d/1bD2-g_Gh53SLDtlVIfbDeeCSzzLTxQVO/preview" width="100%"
					height="400px" frameborder="0"></iframe>
			</div>
			<div class="col-md-4">
				<iframe src="https://drive.google.com/file/d/1gZaD8tlwtS_A-SoXl1CHEgC_lmuXxzHB/preview" width="100%"
					height="400px" frameborder="0"></iframe>
			</div>
			<div class="col-md-4">
				<iframe src="https://drive.google.com/file/d/1bmSd5trOZp8tcQK7mQiqJdXo2V-yKQIE/preview" width="100%"
					height="400px" frameborder="0"></iframe>
			</div>
		</div>
		<div class="row row-cols-1 row-cols-md-2">
			<div class="col">
				<div class="gall-ery">
					<div class="widget_title inner-title gall-sys shadow-text-sm">
						<h4 class="fw-bold">Media Coverage</h4>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-6.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-6.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-6.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-7.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-7.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-7.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-8.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-8.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/media-8.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>

						</ul>
					</div>
				</div>
			</div>

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="col-md-7">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>

					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>

							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>

							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryPune/archery_tour_pune5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>


						</ul>
					</div>
				</div>
			</div>

		</div>

	</div>
</section>
